<div class="row">
    <div class="col-md-12 need-config">
        <div class="row">
            <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-12">
                <div class="card block shadow">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>
                                Nouveau projet
                                <i class="fa fa-question-circle ms-1"
                                   matTooltip="Renseignez les informations de base pour créer votre projet, vous pourrez ensuite l'analyser en détail comme pour une annonce immobilière trouvée sur le moteur de recherche."
                                   #tipNew="matTooltip" (click)="tipNew.show()"></i>
                            </h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-12">
                                <p class="intro">
                                    <b>Créez un projet en partant de zéro (off-market, annonce plus en ligne ...)</b>
                                </p>
                                <mat-form-field>
                                    <mat-label>Prix d'achat</mat-label>
                                    <!-- Champ vide (et non « 0 ») tant que rien n'est saisi ; le modèle garde 0 en interne -->
                                    <input matInput [ngModel]="favorite.price == 0 ? null : favorite.price"
                                           (ngModelChange)="favorite.price = $event; edit($event, 'price')">
                                    <span matSuffix>€</span>
                                    <mat-hint *ngIf="favorite.price == 0 && displayError == true" class="text-red">
                                        Veuillez renseigner le prix
                                    </mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Surface</mat-label>
                                    <input matInput [ngModel]="favorite.square == 0 ? null : favorite.square"
                                           (ngModelChange)="favorite.square = $event; edit($event)">
                                    <span matSuffix>m²</span>
                                </mat-form-field>
                            </div>

                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Ville et/ou code postal</mat-label>
                                    <input type="text"
                                           class="text"
                                           matInput
                                           [(ngModel)]="favorite.ad_city.name"
                                           [formControl]="cityControl"
                                           [matAutocomplete]="auto">
                                    <mat-autocomplete (optionSelected)='changeCity($event.option.value)' autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let city of cities" [value]="city">
                                            {{city.name}}
                                            ({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})
                                        </mat-option>
                                    </mat-autocomplete>
                                    <span matSuffix><div class="citySpinner" style="display: none;"><mat-spinner diameter="20"></mat-spinner></div></span>
                                    <mat-hint *ngIf="favorite.ad_city.zip_code == '' && displayError == true" class="text-red">
                                        Veuillez renseigner la ville
                                    </mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <button (click)="launchSimulation()"
                                        class="btn d-block">
                                    <i class="fa fa-line-chart"></i> Lancer la simulation
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
